import React, { useState } from "react";
import ParkingSlotTable from "../ParkingSlotTable";
import {
  faChevronDown,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "react-bootstrap";
import CategoryIcon from "../../../../../components/CategoryIcon";

export default function ParkingSlotCategory({
  initialCollapsed = true,
  callbackEditCategory,
  callbackToggleDeleteCategory,
  callbackDuplicateParkingSlot,
  category,
  parking_slots,
  callbackSetParkingSlot,
  callbackSetConfirmText,
  callbackToggleEdit,
  callbackSetSelectedTPS,
  selectedParkingSlotIds,
  onToggleSelectedParkingSlot,
  selectionDisabled,
}) {
  const [isCollapsed, setIsCollapsed] = useState(initialCollapsed);

  function handleDeleteCategory() {
    if ((parking_slots?.entries?.length ?? 0) === 0 && !category.is_default) {
      callbackToggleDeleteCategory(category);
    }
  }

  return (
    <div className="w-100 d-flex flex-wrap my-1 category-colors">
      <div className="w-100 d-flex bg-secondary rounded-top rounded-left align-items-center pl-3 text-light p-2">
        <Row className="d-flex w-100">
          <Col
            xs={6}
            className="d-flex align-items-center"
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            <FontAwesomeIcon
              icon={faChevronDown}
              style={{
                transform: !isCollapsed ? "rotate(0)" : "rotate(-90deg)",
                transition: "all 0.2s ease-in-out",
              }}
            />
            <div className="ml-2">
              <CategoryIcon category={category} size={28} />
            </div>
            <span className="ml-2">{category.name}</span>
          </Col>
          <Col xs={6} className="d-flex justify-content-end align-items-center">
            <button
              onClick={() => callbackEditCategory(category.id)}
              type="button"
              className="btn btn-sm text-light"
            >
              <FontAwesomeIcon icon={faEdit} />
            </button>
            <button
              onClick={handleDeleteCategory}
              type="button"
              className={
                "btn btn-sm ml-2 " +
                (parking_slots?.entries?.length > 0 || category.is_default
                  ? "text-secondary force-forbidden"
                  : "text-danger")
              }
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </Col>
        </Row>
      </div>
      {!isCollapsed && (
        <>
          <div className="w-100 pl-md-1 mt-1">
            <ParkingSlotTable
              callbackDuplicateParkingSlot={callbackDuplicateParkingSlot}
              parkingSlots={parking_slots}
              callbackSetParkingSlot={callbackSetParkingSlot}
              callbackSetConfirmText={callbackSetConfirmText}
              callbackToggleEdit={callbackToggleEdit}
              callbackSetSelectedTPS={callbackSetSelectedTPS}
              selectedParkingSlotIds={selectedParkingSlotIds}
              onToggleSelectedParkingSlot={onToggleSelectedParkingSlot}
              selectionDisabled={selectionDisabled}
            />
          </div>
        </>
      )}
    </div>
  );
}
